// src/utils/shippingLocations.js
export const getMenuItemsLocationFrom = (t) => [
  { id: "Europe", name: t("Europe"), flag: "https://flagcdn.com/eu.svg" },
  { id: "Turkey", name: t("Turkey"), flag: "https://flagcdn.com/tr.svg" },
];

export const getMenuItemsLocationTo = (t) => [
  {
    id: "TG",
    name: t("countries.TG"),
    flag: "https://flagcdn.com/tg.svg",
  },
  {
    id: "YT",
    name: t("countries.YT"),
    flag: "https://flagcdn.com/yt.svg",
  },
  {
    id: "GE",
    name: t("countries.GE"),
    flag: "https://flagcdn.com/ge.svg",
  },
  {
    id: "VU",
    name: t("countries.VU"),
    flag: "https://flagcdn.com/vu.svg",
  },
  {
    id: "KG",
    name: t("countries.KG"),
    flag: "https://flagcdn.com/kg.svg",
  },
  {
    id: "NE",
    name: t("countries.NE"),
    flag: "https://flagcdn.com/ne.svg",
  },
  {
    id: "CN",
    name: t("countries.CN"),
    flag: "https://flagcdn.com/cn.svg",
  },
  {
    id: "TV",
    name: t("countries.TV"),
    flag: "https://flagcdn.com/tv.svg",
  },
  {
    id: "KM",
    name: t("countries.KM"),
    flag: "https://flagcdn.com/km.svg",
  },
  {
    id: "BA",
    name: t("countries.BA"),
    flag: "https://flagcdn.com/ba.svg",
  },
  {
    id: "BH",
    name: t("countries.BH"),
    flag: "https://flagcdn.com/bh.svg",
  },
  {
    id: "SO",
    name: t("countries.SO"),
    flag: "https://flagcdn.com/so.svg",
  },
  {
    id: "BL",
    name: t("countries.BL"),
    flag: "https://flagcdn.com/bl.svg",
  },
  {
    id: "LV",
    name: t("countries.LV"),
    flag: "https://flagcdn.com/lv.svg",
  },
  {
    id: "KY",
    name: t("countries.KY"),
    flag: "https://flagcdn.com/ky.svg",
  },
  {
    id: "NL",
    name: t("countries.NL"),
    flag: "https://flagcdn.com/nl.svg",
  },
  {
    id: "LS",
    name: t("countries.LS"),
    flag: "https://flagcdn.com/ls.svg",
  },
  {
    id: "VE",
    name: t("countries.VE"),
    flag: "https://flagcdn.com/ve.svg",
  },
  {
    id: "KE",
    name: t("countries.KE"),
    flag: "https://flagcdn.com/ke.svg",
  },
  {
    id: "TR",
    name: t("countries.TR"),
    flag: "https://flagcdn.com/tr.svg",
  },
  {
    id: "FJ",
    name: t("countries.FJ"),
    flag: "https://flagcdn.com/fj.svg",
  },
  {
    id: "TT",
    name: t("countries.TT"),
    flag: "https://flagcdn.com/tt.svg",
  },
  {
    id: "HN",
    name: t("countries.HN"),
    flag: "https://flagcdn.com/hn.svg",
  },
  {
    id: "JE",
    name: t("countries.JE"),
    flag: "https://flagcdn.com/je.svg",
  },
  {
    id: "DJ",
    name: t("countries.DJ"),
    flag: "https://flagcdn.com/dj.svg",
  },
  {
    id: "RE",
    name: t("countries.RE"),
    flag: "https://flagcdn.com/re.svg",
  },
  {
    id: "SZ",
    name: t("countries.SZ"),
    flag: "https://flagcdn.com/sz.svg",
  },
  {
    id: "TJ",
    name: t("countries.TJ"),
    flag: "https://flagcdn.com/tj.svg",
  },
  {
    id: "SA",
    name: t("countries.SA"),
    flag: "https://flagcdn.com/sa.svg",
  },
  {
    id: "BM",
    name: t("countries.BM"),
    flag: "https://flagcdn.com/bm.svg",
  },
  {
    id: "NZ",
    name: t("countries.NZ"),
    flag: "https://flagcdn.com/nz.svg",
  },
  {
    id: "BY",
    name: t("countries.BY"),
    flag: "https://flagcdn.com/by.svg",
  },
  {
    id: "CX",
    name: t("countries.CX"),
    flag: "https://flagcdn.com/cx.svg",
  },
  {
    id: "GM",
    name: t("countries.GM"),
    flag: "https://flagcdn.com/gm.svg",
  },
  {
    id: "PF",
    name: t("countries.PF"),
    flag: "https://flagcdn.com/pf.svg",
  },
  {
    id: "CD",
    name: t("countries.CD"),
    flag: "https://flagcdn.com/cd.svg",
  },
  {
    id: "CR",
    name: t("countries.CR"),
    flag: "https://flagcdn.com/cr.svg",
  },
  {
    id: "MW",
    name: t("countries.MW"),
    flag: "https://flagcdn.com/mw.svg",
  },
  {
    id: "CG",
    name: t("countries.CG"),
    flag: "https://flagcdn.com/cg.svg",
  },
  {
    id: "OM",
    name: t("countries.OM"),
    flag: "https://flagcdn.com/om.svg",
  },
  {
    id: "IQ",
    name: t("countries.IQ"),
    flag: "https://flagcdn.com/iq.svg",
  },
  {
    id: "NU",
    name: t("countries.NU"),
    flag: "https://flagcdn.com/nu.svg",
  },
  {
    id: "SN",
    name: t("countries.SN"),
    flag: "https://flagcdn.com/sn.svg",
  },
  {
    id: "LB",
    name: t("countries.LB"),
    flag: "https://flagcdn.com/lb.svg",
  },
  {
    id: "AO",
    name: t("countries.AO"),
    flag: "https://flagcdn.com/ao.svg",
  },
  {
    id: "IR",
    name: t("countries.IR"),
    flag: "https://flagcdn.com/ir.svg",
  },
  {
    id: "EC",
    name: t("countries.EC"),
    flag: "https://flagcdn.com/ec.svg",
  },
  {
    id: "LA",
    name: t("countries.LA"),
    flag: "https://flagcdn.com/la.svg",
  },
  {
    id: "LK",
    name: t("countries.LK"),
    flag: "https://flagcdn.com/lk.svg",
  },
  {
    id: "AW",
    name: t("countries.AW"),
    flag: "https://flagcdn.com/aw.svg",
  },
  {
    id: "ST",
    name: t("countries.ST"),
    flag: "https://flagcdn.com/st.svg",
  },
  {
    id: "GD",
    name: t("countries.GD"),
    flag: "https://flagcdn.com/gd.svg",
  },
  {
    id: "MS",
    name: t("countries.MS"),
    flag: "https://flagcdn.com/ms.svg",
  },
  {
    id: "EH",
    name: t("countries.EH"),
    flag: "https://flagcdn.com/eh.svg",
  },
  {
    id: "GN",
    name: t("countries.GN"),
    flag: "https://flagcdn.com/gn.svg",
  },
  {
    id: "VG",
    name: t("countries.VG"),
    flag: "https://flagcdn.com/vg.svg",
  },
  {
    id: "PA",
    name: t("countries.PA"),
    flag: "https://flagcdn.com/pa.svg",
  },
  {
    id: "YE",
    name: t("countries.YE"),
    flag: "https://flagcdn.com/ye.svg",
  },
  {
    id: "EE",
    name: t("countries.EE"),
    flag: "https://flagcdn.com/ee.svg",
  },
  {
    id: "GY",
    name: t("countries.GY"),
    flag: "https://flagcdn.com/gy.svg",
  },
  {
    id: "LU",
    name: t("countries.LU"),
    flag: "https://flagcdn.com/lu.svg",
  },
  {
    id: "NA",
    name: t("countries.NA"),
    flag: "https://flagcdn.com/na.svg",
  },
  {
    id: "XK",
    name: t("countries.XK"),
    flag: "https://flagcdn.com/xk.svg",
  },
  {
    id: "NC",
    name: t("countries.NC"),
    flag: "https://flagcdn.com/nc.svg",
  },
  {
    id: "PM",
    name: t("countries.PM"),
    flag: "https://flagcdn.com/pm.svg",
  },
  {
    id: "LY",
    name: t("countries.LY"),
    flag: "https://flagcdn.com/ly.svg",
  },
  {
    id: "MM",
    name: t("countries.MM"),
    flag: "https://flagcdn.com/mm.svg",
  },
  {
    id: "IL",
    name: t("countries.IL"),
    flag: "https://flagcdn.com/il.svg",
  },
  {
    id: "ML",
    name: t("countries.ML"),
    flag: "https://flagcdn.com/ml.svg",
  },
  {
    id: "AR",
    name: t("countries.AR"),
    flag: "https://flagcdn.com/ar.svg",
  },
  {
    id: "GF",
    name: t("countries.GF"),
    flag: "https://flagcdn.com/gf.svg",
  },
  {
    id: "UG",
    name: t("countries.UG"),
    flag: "https://flagcdn.com/ug.svg",
  },
  {
    id: "MY",
    name: t("countries.MY"),
    flag: "https://flagcdn.com/my.svg",
  },
  {
    id: "ZM",
    name: t("countries.ZM"),
    flag: "https://flagcdn.com/zm.svg",
  },
  {
    id: "FM",
    name: t("countries.FM"),
    flag: "https://flagcdn.com/fm.svg",
  },
  {
    id: "SK",
    name: t("countries.SK"),
    flag: "https://flagcdn.com/sk.svg",
  },
  {
    id: "BI",
    name: t("countries.BI"),
    flag: "https://flagcdn.com/bi.svg",
  },
  {
    id: "RS",
    name: t("countries.RS"),
    flag: "https://flagcdn.com/rs.svg",
  },
  {
    id: "TM",
    name: t("countries.TM"),
    flag: "https://flagcdn.com/tm.svg",
  },
  {
    id: "ZA",
    name: t("countries.ZA"),
    flag: "https://flagcdn.com/za.svg",
  },
  {
    id: "KZ",
    name: t("countries.KZ"),
    flag: "https://flagcdn.com/kz.svg",
  },
  {
    id: "CA",
    name: t("countries.CA"),
    flag: "https://flagcdn.com/ca.svg",
  },
  {
    id: "PL",
    name: t("countries.PL"),
    flag: "https://flagcdn.com/pl.svg",
  },
  {
    id: "PR",
    name: t("countries.PR"),
    flag: "https://flagcdn.com/pr.svg",
  },
  {
    id: "CC",
    name: t("countries.CC"),
    flag: "https://flagcdn.com/cc.svg",
  },
  {
    id: "SM",
    name: t("countries.SM"),
    flag: "https://flagcdn.com/sm.svg",
  },
  {
    id: "AS",
    name: t("countries.AS"),
    flag: "https://flagcdn.com/as.svg",
  },
  {
    id: "QA",
    name: t("countries.QA"),
    flag: "https://flagcdn.com/qa.svg",
  },
  {
    id: "GI",
    name: t("countries.GI"),
    flag: "https://flagcdn.com/gi.svg",
  },
  {
    id: "HR",
    name: t("countries.HR"),
    flag: "https://flagcdn.com/hr.svg",
  },
  {
    id: "SJ",
    name: t("countries.SJ"),
    flag: "https://flagcdn.com/sj.svg",
  },
  {
    id: "IM",
    name: t("countries.IM"),
    flag: "https://flagcdn.com/im.svg",
  },
  {
    id: "PS",
    name: t("countries.PS"),
    flag: "https://flagcdn.com/ps.svg",
  },
  {
    id: "MU",
    name: t("countries.MU"),
    flag: "https://flagcdn.com/mu.svg",
  },
  {
    id: "MF",
    name: t("countries.MF"),
    flag: "https://flagcdn.com/mf.svg",
  },
  {
    id: "SL",
    name: t("countries.SL"),
    flag: "https://flagcdn.com/sl.svg",
  },
  {
    id: "KN",
    name: t("countries.KN"),
    flag: "https://flagcdn.com/kn.svg",
  },
  {
    id: "IS",
    name: t("countries.IS"),
    flag: "https://flagcdn.com/is.svg",
  },
  {
    id: "HM",
    name: t("countries.HM"),
    flag: "https://flagcdn.com/hm.svg",
  },
  {
    id: "KW",
    name: t("countries.KW"),
    flag: "https://flagcdn.com/kw.svg",
  },
  {
    id: "TW",
    name: t("countries.TW"),
    flag: "https://flagcdn.com/tw.svg",
  },
  {
    id: "CM",
    name: t("countries.CM"),
    flag: "https://flagcdn.com/cm.svg",
  },
  {
    id: "SV",
    name: t("countries.SV"),
    flag: "https://flagcdn.com/sv.svg",
  },
  {
    id: "MO",
    name: t("countries.MO"),
    flag: "https://flagcdn.com/mo.svg",
  },
  {
    id: "CU",
    name: t("countries.CU"),
    flag: "https://flagcdn.com/cu.svg",
  },
  {
    id: "BR",
    name: t("countries.BR"),
    flag: "https://flagcdn.com/br.svg",
  },
  {
    id: "SB",
    name: t("countries.SB"),
    flag: "https://flagcdn.com/sb.svg",
  },
  {
    id: "GR",
    name: t("countries.GR"),
    flag: "https://flagcdn.com/gr.svg",
  },
  {
    id: "NO",
    name: t("countries.NO"),
    flag: "https://flagcdn.com/no.svg",
  },
  {
    id: "JM",
    name: t("countries.JM"),
    flag: "https://flagcdn.com/jm.svg",
  },
  {
    id: "TZ",
    name: t("countries.TZ"),
    flag: "https://flagcdn.com/tz.svg",
  },
  {
    id: "BO",
    name: t("countries.BO"),
    flag: "https://flagcdn.com/bo.svg",
  },
  {
    id: "CY",
    name: t("countries.CY"),
    flag: "https://flagcdn.com/cy.svg",
  },
  {
    id: "MN",
    name: t("countries.MN"),
    flag: "https://flagcdn.com/mn.svg",
  },
  {
    id: "MC",
    name: t("countries.MC"),
    flag: "https://flagcdn.com/mc.svg",
  },
  {
    id: "TN",
    name: t("countries.TN"),
    flag: "https://flagcdn.com/tn.svg",
  },
  {
    id: "TF",
    name: t("countries.TF"),
    flag: "https://flagcdn.com/tf.svg",
  },
  {
    id: "SY",
    name: t("countries.SY"),
    flag: "https://flagcdn.com/sy.svg",
  },
  {
    id: "CL",
    name: t("countries.CL"),
    flag: "https://flagcdn.com/cl.svg",
  },
  {
    id: "AZ",
    name: t("countries.AZ"),
    flag: "https://flagcdn.com/az.svg",
  },
  {
    id: "FR",
    name: t("countries.FR"),
    flag: "https://flagcdn.com/fr.svg",
  },
  {
    id: "KR",
    name: t("countries.KR"),
    flag: "https://flagcdn.com/kr.svg",
  },
  {
    id: "GH",
    name: t("countries.GH"),
    flag: "https://flagcdn.com/gh.svg",
  },
  {
    id: "DK",
    name: t("countries.DK"),
    flag: "https://flagcdn.com/dk.svg",
  },
  {
    id: "SX",
    name: t("countries.SX"),
    flag: "https://flagcdn.com/sx.svg",
  },
  {
    id: "AD",
    name: t("countries.AD"),
    flag: "https://flagcdn.com/ad.svg",
  },
  {
    id: "CW",
    name: t("countries.CW"),
    flag: "https://flagcdn.com/cw.svg",
  },
  {
    id: "CH",
    name: t("countries.CH"),
    flag: "https://flagcdn.com/ch.svg",
  },
  {
    id: "MK",
    name: t("countries.MK"),
    flag: "https://flagcdn.com/mk.svg",
  },
  {
    id: "SS",
    name: t("countries.SS"),
    flag: "https://flagcdn.com/ss.svg",
  },
  {
    id: "HT",
    name: t("countries.HT"),
    flag: "https://flagcdn.com/ht.svg",
  },
  {
    id: "PE",
    name: t("countries.PE"),
    flag: "https://flagcdn.com/pe.svg",
  },
  {
    id: "GW",
    name: t("countries.GW"),
    flag: "https://flagcdn.com/gw.svg",
  },
  {
    id: "CZ",
    name: t("countries.CZ"),
    flag: "https://flagcdn.com/cz.svg",
  },
  {
    id: "PT",
    name: t("countries.PT"),
    flag: "https://flagcdn.com/pt.svg",
  },
  {
    id: "GA",
    name: t("countries.GA"),
    flag: "https://flagcdn.com/ga.svg",
  },
  {
    id: "MX",
    name: t("countries.MX"),
    flag: "https://flagcdn.com/mx.svg",
  },
  {
    id: "IT",
    name: t("countries.IT"),
    flag: "https://flagcdn.com/it.svg",
  },
  {
    id: "FI",
    name: t("countries.FI"),
    flag: "https://flagcdn.com/fi.svg",
  },
  {
    id: "ZW",
    name: t("countries.ZW"),
    flag: "https://flagcdn.com/zw.svg",
  },
  {
    id: "ES",
    name: t("countries.ES"),
    flag: "https://flagcdn.com/es.svg",
  },
  {
    id: "JP",
    name: t("countries.JP"),
    flag: "https://flagcdn.com/jp.svg",
  },
  {
    id: "SC",
    name: t("countries.SC"),
    flag: "https://flagcdn.com/sc.svg",
  },
  {
    id: "AL",
    name: t("countries.AL"),
    flag: "https://flagcdn.com/al.svg",
  },
  {
    id: "MD",
    name: t("countries.MD"),
    flag: "https://flagcdn.com/md.svg",
  },
  {
    id: "GT",
    name: t("countries.GT"),
    flag: "https://flagcdn.com/gt.svg",
  },
  {
    id: "DE",
    name: t("countries.DE"),
    flag: "https://flagcdn.com/de.svg",
  },
  {
    id: "GP",
    name: t("countries.GP"),
    flag: "https://flagcdn.com/gp.svg",
  },
  {
    id: "BG",
    name: t("countries.BG"),
    flag: "https://flagcdn.com/bg.svg",
  },
  {
    id: "PY",
    name: t("countries.PY"),
    flag: "https://flagcdn.com/py.svg",
  },
  {
    id: "ER",
    name: t("countries.ER"),
    flag: "https://flagcdn.com/er.svg",
  },
  {
    id: "SD",
    name: t("countries.SD"),
    flag: "https://flagcdn.com/sd.svg",
  },
  {
    id: "GQ",
    name: t("countries.GQ"),
    flag: "https://flagcdn.com/gq.svg",
  },
  {
    id: "CO",
    name: t("countries.CO"),
    flag: "https://flagcdn.com/co.svg",
  },
  {
    id: "NG",
    name: t("countries.NG"),
    flag: "https://flagcdn.com/ng.svg",
  },
  {
    id: "ME",
    name: t("countries.ME"),
    flag: "https://flagcdn.com/me.svg",
  },
  {
    id: "NP",
    name: t("countries.NP"),
    flag: "https://flagcdn.com/np.svg",
  },
  {
    id: "BN",
    name: t("countries.BN"),
    flag: "https://flagcdn.com/bn.svg",
  },
  {
    id: "AT",
    name: t("countries.AT"),
    flag: "https://flagcdn.com/at.svg",
  },
  {
    id: "TC",
    name: t("countries.TC"),
    flag: "https://flagcdn.com/tc.svg",
  },
  {
    id: "BS",
    name: t("countries.BS"),
    flag: "https://flagcdn.com/bs.svg",
  },
  {
    id: "GB",
    name: t("countries.GB"),
    flag: "https://flagcdn.com/gb.svg",
  },
  {
    id: "IO",
    name: t("countries.IO"),
    flag: "https://flagcdn.com/io.svg",
  },
  {
    id: "LR",
    name: t("countries.LR"),
    flag: "https://flagcdn.com/lr.svg",
  },
  {
    id: "AI",
    name: t("countries.AI"),
    flag: "https://flagcdn.com/ai.svg",
  },
  {
    id: "CF",
    name: t("countries.CF"),
    flag: "https://flagcdn.com/cf.svg",
  },
  {
    id: "DZ",
    name: t("countries.DZ"),
    flag: "https://flagcdn.com/dz.svg",
  },
  {
    id: "LC",
    name: t("countries.LC"),
    flag: "https://flagcdn.com/lc.svg",
  },
  {
    id: "RO",
    name: t("countries.RO"),
    flag: "https://flagcdn.com/ro.svg",
  },
  {
    id: "AE",
    name: t("countries.AE"),
    flag: "https://flagcdn.com/ae.svg",
  },
  {
    id: "MA",
    name: t("countries.MA"),
    flag: "https://flagcdn.com/ma.svg",
  },
  {
    id: "MP",
    name: t("countries.MP"),
    flag: "https://flagcdn.com/mp.svg",
  },
  {
    id: "UM",
    name: t("countries.UM"),
    flag: "https://flagcdn.com/um.svg",
  },
  {
    id: "BW",
    name: t("countries.BW"),
    flag: "https://flagcdn.com/bw.svg",
  },
  {
    id: "LT",
    name: t("countries.LT"),
    flag: "https://flagcdn.com/lt.svg",
  },
  {
    id: "BQ",
    name: t("countries.BQ"),
    flag: "https://flagcdn.com/bq.svg",
  },
  {
    id: "CV",
    name: t("countries.CV"),
    flag: "https://flagcdn.com/cv.svg",
  },
  {
    id: "US",
    name: t("countries.US"),
    flag: "https://flagcdn.com/us.svg",
  },
  {
    id: "AU",
    name: t("countries.AU"),
    flag: "https://flagcdn.com/au.svg",
  },
  {
    id: "GU",
    name: t("countries.GU"),
    flag: "https://flagcdn.com/gu.svg",
  },
  {
    id: "TO",
    name: t("countries.TO"),
    flag: "https://flagcdn.com/to.svg",
  },
  {
    id: "AF",
    name: t("countries.AF"),
    flag: "https://flagcdn.com/af.svg",
  },
  {
    id: "FK",
    name: t("countries.FK"),
    flag: "https://flagcdn.com/fk.svg",
  },
  {
    id: "NR",
    name: t("countries.NR"),
    flag: "https://flagcdn.com/nr.svg",
  },
  {
    id: "CK",
    name: t("countries.CK"),
    flag: "https://flagcdn.com/ck.svg",
  },
  {
    id: "HU",
    name: t("countries.HU"),
    flag: "https://flagcdn.com/hu.svg",
  },
  {
    id: "MR",
    name: t("countries.MR"),
    flag: "https://flagcdn.com/mr.svg",
  },
  {
    id: "SI",
    name: t("countries.SI"),
    flag: "https://flagcdn.com/si.svg",
  },
  {
    id: "TD",
    name: t("countries.TD"),
    flag: "https://flagcdn.com/td.svg",
  },
  {
    id: "VA",
    name: t("countries.VA"),
    flag: "https://flagcdn.com/va.svg",
  },
  {
    id: "BJ",
    name: t("countries.BJ"),
    flag: "https://flagcdn.com/bj.svg",
  },
  {
    id: "SG",
    name: t("countries.SG"),
    flag: "https://flagcdn.com/sg.svg",
  },
  {
    id: "MT",
    name: t("countries.MT"),
    flag: "https://flagcdn.com/mt.svg",
  },
  {
    id: "VC",
    name: t("countries.VC"),
    flag: "https://flagcdn.com/vc.svg",
  },
  {
    id: "MH",
    name: t("countries.MH"),
    flag: "https://flagcdn.com/mh.svg",
  },
  {
    id: "TH",
    name: t("countries.TH"),
    flag: "https://flagcdn.com/th.svg",
  },
  {
    id: "LI",
    name: t("countries.LI"),
    flag: "https://flagcdn.com/li.svg",
  },
  {
    id: "IE",
    name: t("countries.IE"),
    flag: "https://flagcdn.com/ie.svg",
  },
  {
    id: "MV",
    name: t("countries.MV"),
    flag: "https://flagcdn.com/mv.svg",
  },
  {
    id: "VN",
    name: t("countries.VN"),
    flag: "https://flagcdn.com/vn.svg",
  },
  {
    id: "AM",
    name: t("countries.AM"),
    flag: "https://flagcdn.com/am.svg",
  },
  {
    id: "PK",
    name: t("countries.PK"),
    flag: "https://flagcdn.com/pk.svg",
  },
  {
    id: "CI",
    name: t("countries.CI"),
    flag: "https://flagcdn.com/ci.svg",
  },
  {
    id: "RU",
    name: t("countries.RU"),
    flag: "https://flagcdn.com/ru.svg",
  },
  {
    id: "MQ",
    name: t("countries.MQ"),
    flag: "https://flagcdn.com/mq.svg",
  },
  {
    id: "BV",
    name: t("countries.BV"),
    flag: "https://flagcdn.com/bv.svg",
  },
  {
    id: "TL",
    name: t("countries.TL"),
    flag: "https://flagcdn.com/tl.svg",
  },
  {
    id: "NI",
    name: t("countries.NI"),
    flag: "https://flagcdn.com/ni.svg",
  },
  {
    id: "PG",
    name: t("countries.PG"),
    flag: "https://flagcdn.com/pg.svg",
  },
  {
    id: "EG",
    name: t("countries.EG"),
    flag: "https://flagcdn.com/eg.svg",
  },
  {
    id: "JO",
    name: t("countries.JO"),
    flag: "https://flagcdn.com/jo.svg",
  },
  {
    id: "UY",
    name: t("countries.UY"),
    flag: "https://flagcdn.com/uy.svg",
  },
  {
    id: "BF",
    name: t("countries.BF"),
    flag: "https://flagcdn.com/bf.svg",
  },
  {
    id: "KH",
    name: t("countries.KH"),
    flag: "https://flagcdn.com/kh.svg",
  },
  {
    id: "ET",
    name: t("countries.ET"),
    flag: "https://flagcdn.com/et.svg",
  },
  {
    id: "KI",
    name: t("countries.KI"),
    flag: "https://flagcdn.com/ki.svg",
  },
  {
    id: "BT",
    name: t("countries.BT"),
    flag: "https://flagcdn.com/bt.svg",
  },
  {
    id: "DO",
    name: t("countries.DO"),
    flag: "https://flagcdn.com/do.svg",
  },
  {
    id: "SR",
    name: t("countries.SR"),
    flag: "https://flagcdn.com/sr.svg",
  },
  {
    id: "BD",
    name: t("countries.BD"),
    flag: "https://flagcdn.com/bd.svg",
  },
  {
    id: "BB",
    name: t("countries.BB"),
    flag: "https://flagcdn.com/bb.svg",
  },
  {
    id: "KP",
    name: t("countries.KP"),
    flag: "https://flagcdn.com/kp.svg",
  },
  {
    id: "GL",
    name: t("countries.GL"),
    flag: "https://flagcdn.com/gl.svg",
  },
  {
    id: "BE",
    name: t("countries.BE"),
    flag: "https://flagcdn.com/be.svg",
  },
  {
    id: "PW",
    name: t("countries.PW"),
    flag: "https://flagcdn.com/pw.svg",
  },
  {
    id: "NF",
    name: t("countries.NF"),
    flag: "https://flagcdn.com/nf.svg",
  },
  {
    id: "GS",
    name: t("countries.GS"),
    flag: "https://flagcdn.com/gs.svg",
  },
  {
    id: "PH",
    name: t("countries.PH"),
    flag: "https://flagcdn.com/ph.svg",
  },
  {
    id: "IN",
    name: t("countries.IN"),
    flag: "https://flagcdn.com/in.svg",
  },
  {
    id: "ID",
    name: t("countries.ID"),
    flag: "https://flagcdn.com/id.svg",
  },
  {
    id: "VI",
    name: t("countries.VI"),
    flag: "https://flagcdn.com/vi.svg",
  },
  {
    id: "DM",
    name: t("countries.DM"),
    flag: "https://flagcdn.com/dm.svg",
  },
  {
    id: "RW",
    name: t("countries.RW"),
    flag: "https://flagcdn.com/rw.svg",
  },
  {
    id: "MG",
    name: t("countries.MG"),
    flag: "https://flagcdn.com/mg.svg",
  },
  {
    id: "HK",
    name: t("countries.HK"),
    flag: "https://flagcdn.com/hk.svg",
  },
  {
    id: "WS",
    name: t("countries.WS"),
    flag: "https://flagcdn.com/ws.svg",
  },
  {
    id: "FO",
    name: t("countries.FO"),
    flag: "https://flagcdn.com/fo.svg",
  },
  {
    id: "PN",
    name: t("countries.PN"),
    flag: "https://flagcdn.com/pn.svg",
  },
  {
    id: "AG",
    name: t("countries.AG"),
    flag: "https://flagcdn.com/ag.svg",
  },
  {
    id: "AX",
    name: t("countries.AX"),
    flag: "https://flagcdn.com/ax.svg",
  },
  {
    id: "SE",
    name: t("countries.SE"),
    flag: "https://flagcdn.com/se.svg",
  },
  {
    id: "MZ",
    name: t("countries.MZ"),
    flag: "https://flagcdn.com/mz.svg",
  },
  {
    id: "UZ",
    name: t("countries.UZ"),
    flag: "https://flagcdn.com/uz.svg",
  },
  {
    id: "AQ",
    name: t("countries.AQ"),
    flag: "https://flagcdn.com/aq.svg",
  },
  {
    id: "WF",
    name: t("countries.WF"),
    flag: "https://flagcdn.com/wf.svg",
  },
  {
    id: "UA",
    name: t("countries.UA"),
    flag: "https://flagcdn.com/ua.svg",
  },
  {
    id: "BZ",
    name: t("countries.BZ"),
    flag: "https://flagcdn.com/bz.svg",
  },
  {
    id: "SH",
    name: t("countries.SH"),
    flag: "https://flagcdn.com/sh.svg",
  },
  {
    id: "GG",
    name: t("countries.GG"),
    flag: "https://flagcdn.com/gg.svg",
  },
  {
    id: "TK",
    name: t("countries.TK"),
    flag: "https://flagcdn.com/tk.svg",
  },
];
export const getMenuItemscountryTo = () => [
  {
    en: "Togo",
    ar: "توغو",
  },
  {
    en: "Mayotte",
    ar: "مايوت",
  },
  {
    en: "Georgia",
    ar: "جورجيا",
  },
  {
    en: "Vanuatu",
    ar: "فانواتو",
  },
  {
    en: "Kyrgyzstan",
    ar: "قيرغيزستان",
  },
  {
    en: "Niger",
    ar: "النيجر",
  },
  {
    en: "China",
    ar: "الصين",
  },
  {
    en: "Tuvalu",
    ar: "توفالو",
  },
  {
    en: "Comoros",
    ar: "جزر القمر",
  },
  {
    en: "Bosnia and Herzegovina",
    ar: "البوسنة والهرسك",
  },
  {
    en: "Bahrain",
    ar: "البحرين",
  },
  {
    en: "Somalia",
    ar: "الصومال",
  },
  {
    en: "Saint Barthélemy",
    ar: "سان بارتليمي",
  },
  {
    en: "Latvia",
    ar: "لاتفيا",
  },
  {
    en: "Cayman Islands",
    ar: "جزر كايمان",
  },
  {
    en: "Netherlands",
    ar: "هولندا",
  },
  {
    en: "Lesotho",
    ar: "ليسوتو",
  },
  {
    en: "Venezuela",
    ar: "فنزويلا",
  },
  {
    en: "Kenya",
    ar: "كينيا",
  },
  {
    en: "Turkey",
    ar: "تركيا",
  },
  {
    en: "Fiji",
    ar: "فيجي",
  },
  {
    en: "Trinidad and Tobago",
    ar: "ترينيداد وتوباغو",
  },
  {
    en: "Honduras",
    ar: "هندوراس",
  },
  {
    en: "Jersey",
    ar: "جيرزي",
  },
  {
    en: "Djibouti",
    ar: "جيبوتي",
  },
  {
    en: "Réunion",
    ar: "لا ريونيون",
  },
  {
    en: "Eswatini",
    ar: "إسواتيني",
  },
  {
    en: "Tajikistan",
    ar: "طاجيكستان",
  },
  {
    en: "Saudi Arabia",
    ar: "السعودية",
  },
  {
    en: "Bermuda",
    ar: "برمودا",
  },
  {
    en: "New Zealand",
    ar: "نيوزيلندا",
  },
  {
    en: "Belarus",
    ar: "بيلاروسيا",
  },
  {
    en: "Christmas Island",
    ar: "جزيرة كريسماس",
  },
  {
    en: "Gambia",
    ar: "غامبيا",
  },
  {
    en: "French Polynesia",
    ar: "بولينزيا الفرنسية",
  },
  {
    en: "DR Congo",
    ar: "الكونغو",
  },
  {
    en: "Costa Rica",
    ar: "كوستاريكا",
  },
  {
    en: "Malawi",
    ar: "مالاوي",
  },
  {
    en: "Republic of the Congo",
    ar: "جمهورية الكونفو",
  },
  {
    en: "Oman",
    ar: "عمان",
  },
  {
    en: "Iraq",
    ar: "العراق",
  },
  {
    en: "Niue",
    ar: "نييوي",
  },
  {
    en: "Senegal",
    ar: "السنغال",
  },
  {
    en: "Lebanon",
    ar: "لبنان",
  },
  {
    en: "Angola",
    ar: "جمهورية أنغولا",
  },
  {
    en: "Iran",
    ar: "إيران",
  },
  {
    en: "Ecuador",
    ar: "الإكوادور",
  },
  {
    en: "Laos",
    ar: "لاوس",
  },
  {
    en: "Sri Lanka",
    ar: "سريلانكا",
  },
  {
    en: "Aruba",
    ar: "أروبا",
  },
  {
    en: "São Tomé and Príncipe",
    ar: "ساو تومي وبرينسيب",
  },
  {
    en: "Grenada",
    ar: "غرينادا",
  },
  {
    en: "Montserrat",
    ar: "مونتسرات",
  },
  {
    en: "Western Sahara",
    ar: "الصحراء الغربية",
  },
  {
    en: "Guinea",
    ar: "غينيا",
  },
  {
    en: "British Virgin Islands",
    ar: "جزر العذراء",
  },
  {
    en: "Panama",
    ar: "بنما",
  },
  {
    en: "Yemen",
    ar: "اليمن",
  },
  {
    en: "Estonia",
    ar: "إستونيا",
  },
  {
    en: "Guyana",
    ar: "غيانا",
  },
  {
    en: "Luxembourg",
    ar: "لوكسمبورغ",
  },
  {
    en: "Namibia",
    ar: "ناميبيا",
  },
  {
    en: "Kosovo",
    ar: "كوسوفو",
  },
  {
    en: "New Caledonia",
    ar: "كاليدونيا الجديدة",
  },
  {
    en: "Saint Pierre and Miquelon",
    ar: "سان بيير وميكلون",
  },
  {
    en: "Libya",
    ar: "ليبيا",
  },
  {
    en: "Myanmar",
    ar: "ميانمار",
  },
  {
    en: "Israel",
    ar: "إسرائيل",
  },
  {
    en: "Mali",
    ar: "مالي",
  },
  {
    en: "Argentina",
    ar: "الأرجنتين",
  },
  {
    en: "French Guiana",
    ar: "غويانا",
  },
  {
    en: "Uganda",
    ar: "أوغندا",
  },
  {
    en: "Malaysia",
    ar: "ماليزيا",
  },
  {
    en: "Zambia",
    ar: "زامبيا",
  },
  {
    en: "Micronesia",
    ar: "ميكرونيسيا",
  },
  {
    en: "Slovakia",
    ar: "سلوفاكيا",
  },
  {
    en: "Burundi",
    ar: "بوروندي",
  },
  {
    en: "Serbia",
    ar: "صيربيا",
  },
  {
    en: "Turkmenistan",
    ar: "تركمانستان",
  },
  {
    en: "South Africa",
    ar: "جنوب أفريقيا",
  },
  {
    en: "Kazakhstan",
    ar: "كازاخستان",
  },
  {
    en: "Canada",
    ar: "كندا",
  },
  {
    en: "Poland",
    ar: "بولندا",
  },
  {
    en: "Puerto Rico",
    ar: "بويرتوريكو",
  },
  {
    en: "Cocos (Keeling) Islands",
    ar: "جزر كوكوس",
  },
  {
    en: "San Marino",
    ar: "سان مارينو",
  },
  {
    en: "American Samoa",
    ar: "ساموا الأمريكية",
  },
  {
    en: "Qatar",
    ar: "قطر",
  },
  {
    en: "Gibraltar",
    ar: "جبل طارق",
  },
  {
    en: "Croatia",
    ar: "كرواتيا",
  },
  {
    en: "Svalbard and Jan Mayen",
    ar: "سفالبارد ويان ماين",
  },
  {
    en: "Isle of Man",
    ar: "جزيرة مان",
  },
  {
    en: "Palestine",
    ar: "فلسطين",
  },
  {
    en: "Mauritius",
    ar: "موريشيوس",
  },
  {
    en: "Saint Martin",
    ar: "سانت مارتن",
  },
  {
    en: "Sierra Leone",
    ar: "سيراليون",
  },
  {
    en: "Saint Kitts and Nevis",
    ar: "سانت كيتس ونيفيس",
  },
  {
    en: "Iceland",
    ar: "آيسلندا",
  },
  {
    en: "Heard Island and McDonald Islands",
    ar: "جزيرة هيرد وجزر ماكدونالد",
  },
  {
    en: "Kuwait",
    ar: "الكويت",
  },
  {
    en: "Taiwan",
    ar: "تايوان",
  },
  {
    en: "Cameroon",
    ar: "الكاميرون",
  },
  {
    en: "El Salvador",
    ar: "السلفادور",
  },
  {
    en: "Macau",
    ar: "ماكاو",
  },
  {
    en: "Cuba",
    ar: "كوبا",
  },
  {
    en: "Brazil",
    ar: "البرازيل",
  },
  {
    en: "Solomon Islands",
    ar: "جزر سليمان",
  },
  {
    en: "Greece",
    ar: "اليونان",
  },
  {
    en: "Norway",
    ar: "النرويج",
  },
  {
    en: "Jamaica",
    ar: "جامايكا",
  },
  {
    en: "Tanzania",
    ar: "تنزانيا",
  },
  {
    en: "Bolivia",
    ar: "بوليفيا",
  },
  {
    en: "Cyprus",
    ar: "قبرص",
  },
  {
    en: "Mongolia",
    ar: "منغوليا",
  },
  {
    en: "Monaco",
    ar: "موناكو",
  },
  {
    en: "Tunisia",
    ar: "تونس",
  },
  {
    en: "French Southern and Antarctic Lands",
    ar: "أراض فرنسية جنوبية وأنتارتيكية",
  },
  {
    en: "Syria",
    ar: "سوريا",
  },
  {
    en: "Chile",
    ar: "تشيلي",
  },
  {
    en: "Azerbaijan",
    ar: "أذربيجان",
  },
  {
    en: "France",
    ar: "فرنسا",
  },
  {
    en: "South Korea",
    ar: "كوريا الجنوبية",
  },
  {
    en: "Ghana",
    ar: "غانا",
  },
  {
    en: "Denmark",
    ar: "الدنمارك",
  },
  {
    en: "Sint Maarten",
    ar: "سينت مارتن",
  },
  {
    en: "Andorra",
    ar: "أندورا",
  },
  {
    en: "Curaçao",
    ar: "كوراساو",
  },
  {
    en: "Switzerland",
    ar: "سويسرا",
  },
  {
    en: "North Macedonia",
    ar: "شمال مقدونيا",
  },
  {
    en: "South Sudan",
    ar: "جنوب السودان",
  },
  {
    en: "Haiti",
    ar: "هايتي",
  },
  {
    en: "Peru",
    ar: "بيرو",
  },
  {
    en: "Guinea-Bissau",
    ar: "غينيا بيساو",
  },
  {
    en: "Czechia",
    ar: "التشيك",
  },
  {
    en: "Portugal",
    ar: "البرتغال",
  },
  {
    en: "Gabon",
    ar: "الغابون",
  },
  {
    en: "Mexico",
    ar: "المسكيك",
  },
  {
    en: "Italy",
    ar: "إيطاليا",
  },
  {
    en: "Finland",
    ar: "فنلندا",
  },
  {
    en: "Zimbabwe",
    ar: "زيمبابوي",
  },
  {
    en: "Spain",
    ar: "إسبانيا",
  },
  {
    en: "Japan",
    ar: "اليابان",
  },
  {
    en: "Seychelles",
    ar: "سيشل",
  },
  {
    en: "Albania",
    ar: "ألبانيا",
  },
  {
    en: "Moldova",
    ar: "مولدوڤا",
  },
  {
    en: "Guatemala",
    ar: "غواتيمالا",
  },
  {
    en: "Germany",
    ar: "ألمانيا",
  },
  {
    en: "Guadeloupe",
    ar: "غوادلوب",
  },
  {
    en: "Bulgaria",
    ar: "بلغاريا",
  },
  {
    en: "Paraguay",
    ar: "باراغواي",
  },
  {
    en: "Eritrea",
    ar: "إريتريا",
  },
  {
    en: "Sudan",
    ar: "السودان",
  },
  {
    en: "Equatorial Guinea",
    ar: "غينيا الاستوائية",
  },
  {
    en: "Colombia",
    ar: "كولومبيا",
  },
  {
    en: "Nigeria",
    ar: "نيجيريا",
  },
  {
    en: "Montenegro",
    ar: "الجبل الاسود",
  },
  {
    en: "Nepal",
    ar: "نيبال",
  },
  {
    en: "Brunei",
    ar: "بروناي",
  },
  {
    en: "Austria",
    ar: "النمسا",
  },
  {
    en: "Turks and Caicos Islands",
    ar: "جزر توركس وكايكوس",
  },
  {
    en: "Bahamas",
    ar: "باهاماس",
  },
  {
    en: "United Kingdom",
    ar: "المملكة المتحدة",
  },
  {
    en: "British Indian Ocean Territory",
    ar: "إقليم المحيط الهندي البريطاني",
  },
  {
    en: "Liberia",
    ar: "ليبيريا",
  },
  {
    en: "Anguilla",
    ar: "أنغويلا",
  },
  {
    en: "Central African Republic",
    ar: "جمهورية أفريقيا الوسطى",
  },
  {
    en: "Algeria",
    ar: "الجزائر",
  },
  {
    en: "Saint Lucia",
    ar: "سانت لوسيا",
  },
  {
    en: "Romania",
    ar: "رومانيا",
  },
  {
    en: "United Arab Emirates",
    ar: "دولة الإمارات العربية المتحدة",
  },
  {
    en: "Morocco",
    ar: "المغرب",
  },
  {
    en: "Northern Mariana Islands",
    ar: "جزر ماريانا الشمالية",
  },
  {
    en: "United States Minor Outlying Islands",
    ar: "جزر الولايات المتحدة الصغيرة النائية",
  },
  {
    en: "Botswana",
    ar: "بوتسوانا",
  },
  {
    en: "Lithuania",
    ar: "ليتوانيا",
  },
  {
    en: "Caribbean Netherlands",
    ar: "الجزر الكاريبية الهولندية",
  },
  {
    en: "Cape Verde",
    ar: "كابو فيردي",
  },
  {
    en: "United States",
    ar: "الولايات المتحدة",
  },
  {
    en: "Australia",
    ar: "أستراليا",
  },
  {
    en: "Guam",
    ar: "غوام",
  },
  {
    en: "Tonga",
    ar: "تونغا",
  },
  {
    en: "Afghanistan",
    ar: "أفغانستان",
  },
  {
    en: "Falkland Islands",
    ar: "جزر فوكلاند",
  },
  {
    en: "Nauru",
    ar: "ناورو",
  },
  {
    en: "Cook Islands",
    ar: "جزر كوك",
  },
  {
    en: "Hungary",
    ar: "المجر",
  },
  {
    en: "Mauritania",
    ar: "موريتانيا",
  },
  {
    en: "Slovenia",
    ar: "سلوفينيا",
  },
  {
    en: "Chad",
    ar: "تشاد",
  },
  {
    en: "Vatican City",
    ar: "مدينة الفاتيكان",
  },
  {
    en: "Benin",
    ar: "بنين",
  },
  {
    en: "Singapore",
    ar: "سنغافورة",
  },
  {
    en: "Malta",
    ar: "مالطا",
  },
  {
    en: "Saint Vincent and the Grenadines",
    ar: "سانت فينسنت والغرينادين",
  },
  {
    en: "Marshall Islands",
    ar: "جزر مارشال",
  },
  {
    en: "Thailand",
    ar: "تايلند",
  },
  {
    en: "Liechtenstein",
    ar: "ليختنشتاين",
  },
  {
    en: "Ireland",
    ar: "أيرلندا",
  },
  {
    en: "Maldives",
    ar: "المالديف",
  },
  {
    en: "Vietnam",
    ar: "فيتنام",
  },
  {
    en: "Armenia",
    ar: "أرمينيا",
  },
  {
    en: "Pakistan",
    ar: "باكستان",
  },
  {
    en: "Ivory Coast",
    ar: "ساحل العاج",
  },
  {
    en: "Russia",
    ar: "روسيا",
  },
  {
    en: "Martinique",
    ar: "مارتينيك",
  },
  {
    en: "Bouvet Island",
    ar: "جزر بوفيه",
  },
  {
    en: "Timor-Leste",
    ar: "تيمور الشرقية",
  },
  {
    en: "Nicaragua",
    ar: "نيكاراغوا",
  },
  {
    en: "Papua New Guinea",
    ar: "بابوا غينيا الجديدة",
  },
  {
    en: "Egypt",
    ar: "مصر",
  },
  {
    en: "Jordan",
    ar: "الأردن",
  },
  {
    en: "Uruguay",
    ar: "الأوروغواي",
  },
  {
    en: "Burkina Faso",
    ar: "بوركينا فاسو",
  },
  {
    en: "Cambodia",
    ar: "كمبوديا",
  },
  {
    en: "Ethiopia",
    ar: "إثيوبيا",
  },
  {
    en: "Kiribati",
    ar: "كيريباتي",
  },
  {
    en: "Bhutan",
    ar: "بوتان",
  },
  {
    en: "Dominican Republic",
    ar: "جمهورية الدومينيكان",
  },
  {
    en: "Suriname",
    ar: "سورينام",
  },
  {
    en: "Bangladesh",
    ar: "بنغلاديش",
  },
  {
    en: "Barbados",
    ar: "باربادوس",
  },
  {
    en: "North Korea",
    ar: "كوريا الشمالية",
  },
  {
    en: "Greenland",
    ar: "جرينلاند",
  },
  {
    en: "Belgium",
    ar: "بلجيكا",
  },
  {
    en: "Palau",
    ar: "بالاو",
  },
  {
    en: "Norfolk Island",
    ar: "جزيرة نورفولك",
  },
  {
    en: "South Georgia",
    ar: "جورجيا الجنوبية",
  },
  {
    en: "Philippines",
    ar: "الفلبين",
  },
  {
    en: "India",
    ar: "الهند",
  },
  {
    en: "Indonesia",
    ar: "إندونيسيا",
  },
  {
    en: "United States Virgin Islands",
    ar: "جزر العذراء الامريكية",
  },
  {
    en: "Dominica",
    ar: "دومينيكا",
  },
  {
    en: "Rwanda",
    ar: "رواندا",
  },
  {
    en: "Madagascar",
    ar: "مدغشقر",
  },
  {
    en: "Hong Kong",
    ar: "هونغ كونغ",
  },
  {
    en: "Samoa",
    ar: "ساموا",
  },
  {
    en: "Faroe Islands",
    ar: "جزر فارو",
  },
  {
    en: "Pitcairn Islands",
    ar: "جزر بيتكيرن",
  },
  {
    en: "Antigua and Barbuda",
    ar: "أنتيغوا وباربودا",
  },
  {
    en: "Åland Islands",
    ar: "جزر أولاند",
  },
  {
    en: "Sweden",
    ar: "السويد",
  },
  {
    en: "Mozambique",
    ar: "موزمبيق",
  },
  {
    en: "Uzbekistan",
    ar: "أوزباكستان",
  },
  {
    en: "Antarctica",
    ar: "أنتارتيكا",
  },
  {
    en: "Wallis and Futuna",
    ar: "واليس وفوتونا",
  },
  {
    en: "Ukraine",
    ar: "أوكرانيا",
  },
  {
    en: "Belize",
    ar: "بليز",
  },
  {
    en: "Saint Helena, Ascension and Tristan da Cunha",
    ar: "سانت هيلينا وأسينشين وتريستان دا كونا",
  },
  {
    en: "Guernsey",
    ar: "غيرنزي",
  },
  {
    en: "Tokelau",
    ar: "توكيلاو",
  },
];
